import { useStepper } from "@/components/ui/stepper";
import { cn } from "@/lib/utils";

export function StepperSidebar() {
  const { currentStep } = useStepper();

  return (
    <div className="min-w-[300px] border-l border-gray-200 flex flex-col gap-y-2 pl-4">
      <StepLabel label="1. Plan Basics" isActive={currentStep == 1} />
      <StepLabel label="2. Deals" isActive={currentStep == 2} />
      <StepLabel label="3. Rates" isActive={currentStep == 3} />
    </div>
  );
}

interface StepLabelProps {
  label: string;
  isActive?: boolean;
}

function StepLabel({ label, isActive = false }: StepLabelProps) {
  return (
    <div className={cn("", isActive ? "font-medium" : "text-gray-500")}>
      {label}
    </div>
  );
}
